
const CancelResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
	// "result": {}
		"gdsRefrenceID": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
		"cancelCode": "string",
		"statusCode": 100
	
};
 

  export default CancelResponse;
  